import axios from "axios";
axios.defaults.withCredentials = true;
const baseURL = 'https://preclinique.co.uk/api'; //development server

//const baseURL = "http://localhost:8000/api"; //localhost

//NODE_ENV = 'development'
//NODE_ENV = 'production'

export async function onRegistration(registrationData) {
  return await axios.post(`${baseURL}/register`, registrationData);
}

export async function getSubId(userId) {
  try {
    const response = await axios.get(
      `${baseURL}/get-subscription-id/${userId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}



export async function updateCustomerId(userId, customerId) {
    return await axios.post(
        `${baseURL}/update-customer-id`,
        {
            userId: userId,
            customerId: customerId,
        }
    );
}


export async function createCustomerPortalSession(userId) {
    return await axios.post(
        `${baseURL}/create-customer-portal-session`,

        {
            // ⭐️ Explicitly adding userId to the request body as requested ⭐️
            userId: userId,
        } // Empty body, as user identification is handled via the request header/session
    );
}


export async function stripeCheckoutMonthly(userId, universityName, course) {
  return await axios.post(
    `${baseURL}/create-stripe-checkout-session-for-monthly`,
    {
      userId: userId,
      university_name: universityName,
      course: course,
    }
  );
}

export async function stripeCheckoutYearly(userId, universityName, course) {
  return await axios.post(
    `${baseURL}/create-stripe-checkout-session-for-yearly`,
    {
      userId: userId,
      university_name: universityName,
      course: course,
    }
  );
}

export async function getSubscriptionStatus() {
  try {
    const response = await axios.get(`${baseURL}/subscription/status`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getPaidStatus(userId) {
  try {
    const response = await axios.get(`${baseURL}/getPaidStatus/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function cancelSubscription(subscriptionId) {
  try {
    const response = await axios.post(
      `${baseURL}/cancel-subscription/${subscriptionId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function onLogin(loginData) {
  return await axios.post(`${baseURL}/login`, loginData);
}

export async function onLogout() {
  return await axios.get(`${baseURL}/logout`);
}

export async function fetchProtectedInfo() {
  return await axios.get(`${baseURL}/protected`);
}

export async function getUserDetails() {
  return await axios.get(`${baseURL}/getUserDetails`);
}

export async function updateUserDetails(updateData) {
  return await axios.put(`${baseURL}/updateUserDetails`, updateData);
}

export async function initiatePasswordReset(emailData) {
  return await axios.post(`${baseURL}/reset-password/initiate`, emailData);
}

export async function resetPassword(passwordData) {
  return await axios.post(`${baseURL}/reset-password/insert`, passwordData);
}

export async function updatePassword(passwordData) {
  return await axios.put(`${baseURL}/updatePassword`, passwordData);
}

export async function confirmEmail(confirmation_token) {
  return await axios.get(
    `${baseURL}/confirm-account?confirmation_token=${confirmation_token}`
  );
}

export async function getAllMainCategoriesWithQuestionCount(
  universityName,
  courseName
) {
  return await axios.get(
    `${baseURL}/question-bank/categories?university_name=${encodeURIComponent(
      universityName
    )}&course_name=${encodeURIComponent(courseName)}`
  );
}

export async function getSubcategoriesByMainCategoryWithQuestionCount(
  categoryId,
  userId
) {
  return await axios.get(
    `${baseURL}/question-bank/categories/${categoryId}/subcategories?userId=${userId}`
  );
}

export async function getQuestionsBySubcategories(
  subcategoryIds,
  //userId,
  type = 1,
  excludedQuestionIds = []
) {
  console.log("Received parameters:");
  console.log("subcategoryIds:", subcategoryIds);
  //console.log("userId:", userId);
  console.log("type:", type);
  console.log("excludedQuestionIds:", excludedQuestionIds);

  const queryParams = new URLSearchParams({
    subcategories: subcategoryIds.join(","), // Convert array to comma-separated string
    //userId: userId,
    type: type,
    excludedQuestionIds: excludedQuestionIds.join(","), // Convert array to comma-separated string
  });

  const url = `${baseURL}/question-bank/questions?${queryParams}`;

  console.log("Constructed URL:", url);

  return await axios.get(url);
}

export async function getQuestionsToExclude(userId) {
  return await axios.get(
    `${baseURL}/question-bank/getQuestionsToExclude?user_id=${userId}`
  );
}

export async function getCountOfQuestionsByUniversityAndCourse(
  course,
  university_name
) {
  return await axios.get(
    `${baseURL}/question-bank/getCountOfQuestionsByUniversityAndCourse?course=${course}&university_name=${university_name}`
  );
}

export async function getQuestionsByIds(questionIds, userId) {
  const questionsQuery = questionIds.join(",");
  return await axios.get(
    `${baseURL}/question-bank/getQuestionsByIds?questions=${questionsQuery}&userId=${userId}`
  );
}

export async function getMockQuestionsByIds(questionIds, userId) {
  const questionsQuery = questionIds.join(",");
  return await axios.get(
    `${baseURL}/question-bank/getMockQuestionsByIds?questions=${questionsQuery}&userId=${userId}`
  );
}

export async function getOlderMockExams(university_name, course, user_id) {
    try {
        const response = await axios.get(
            `${baseURL}/question-bank/older-mock-exams`,
            {
                params: {
                    university_name,
                    course,
                    user_id
                }
            }
        );
        return response.data;  // ✅ This includes { success, mockExams }
    } catch (error) {
        console.error("Error fetching older mock exams:", error.message);
        throw error;
    }
}


// Add this new function after the existing `getMockQuestions` function.

export async function getMockQuestionsByMockName(university_name, course, mock_name) {
    try {
        return await axios.get(`${baseURL}/question-bank/getMockQuestionsByMockName`, {
            params: { university_name, course, mock_name }
        });
    } catch (error) {
        console.error("Error fetching mock questions by mock name:", error.message);
        throw error;
    }
}


export async function getMockQuestions(course, university_name, mock_name) {
  return await axios.get(
    `${baseURL}/question-bank/getMockQuestionsByUniversity?university_name=${university_name}&course=${course}&mock_name=${mock_name}`
  );
}

export async function submitMockQuestionData(
  question_id,
  chosen_option_id,
  is_correct,
  user_id,
  mock_name
) {
  const data = { question_id, chosen_option_id, is_correct, user_id, mock_name };

  try {
    const response = await axios.post(
      `${baseURL}/question-bank/submitMockQuestionData`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting mock question data:", error);
    throw error;
  }
}

export async function saveMockSession(payload) {
  try {
    const response = await axios.post(
      `${baseURL}/question-bank/mock-session`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error saving mock session:", error.message);
    throw error;
  }
}

export async function getMockSession(userId, mockName) {
  try {
    const response = await axios.get(`${baseURL}/question-bank/mock-session`, {
      params: { user_id: userId, mock_name: mockName },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching mock session:", error.message);
    throw error;
  }
}

export async function deleteMockSession(userId, mockName) {
  try {
    const response = await axios.delete(
      `${baseURL}/question-bank/mock-session`,
      { params: { user_id: userId, mock_name: mockName } }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting mock session:", error.message);
    throw error;
  }
}

export async function clearMockProgress(userId, mockName) {
  try {
    const response = await axios.delete(
      `${baseURL}/question-bank/mock-progress`,
      { params: { user_id: userId, mock_name: mockName } }
    );
    return response.data;
  } catch (error) {
    console.error("Error clearing mock progress:", error.message);
    throw error;
  }
}

export async function submitLongFormatQuestionInMockForReview(submissionData) {
  const data = submissionData; // Spread the submission data into the request body

  try {
    const response = await axios.post(
      `${baseURL}/question-bank/submitLongFormatQuestionInMockForReview`,
      data
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error submitting long-format question for review:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function getUserLongFormatMockSubmissions(userId, mock_name) {
    try {
        const response = await axios.get(
            `${baseURL}/question-bank/getUserLongFormatMockSubmissions/?user_id=${userId}&mock_name=${mock_name}`
        );
        return response.data; // Return the response from the backend
    } catch (error) {
        console.error("Error fetching user submissions:", error);
        throw error; // Rethrow error to be handled by the calling
    }
}

export async function getMaxPossibleLongFormatScores(universityName, mock_name, course) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/getMaxPossibleLongFormatScores/?university_name=${universityName}&mock_name=${mock_name}&course=${course}`
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error fetching max possible long format scores:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function countType1QuestionsForMock(universityName, mock_name, course) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/countType1QuestionsForMock/?university_name=${universityName}&mock_name=${mock_name}&course=${course}`
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error counting Type 1 questions:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function getMockMaxMarksSummary(universityName, course, mock_name) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/getMockMaxMarksSummary/`,
      {
        params: {
          // Properly encode query parameters
          university_name: universityName,
              course: course,
          mock_name: mock_name,
        },
      }
    );
    console.log("Mock Marks Summary:", response.data); // Added console log
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching mock marks summary:",
      error.response?.data || error.message
    );
    throw error; // Rethrow for calling function to handle
  }
}

export async function markQuestionAsCorrect(userId, questionId, mark, mock_name) {
  try {
    const response = await axios.put(
      `${baseURL}/question-bank/markLongQuestionAsCorrect`,
      { user_id: userId, question_id: questionId, mark, mock_name }
    );
    return response.data;
  } catch (error) {
    console.error("Error marking question as correct:", error);
    throw error;
  }
}

export async function markQuestionAsIncorrect(userId, questionId) {
  try {
    const response = await axios.put(
      `${baseURL}/question-bank/markLongQuestionAsIncorrect`,
      { user_id: userId, question_id: questionId }
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error marking question as incorrect:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function submitMockQuestionResults(userId, answers, mock_name) {
  try {
    const response = await axios.post(
      `${baseURL}/question-bank/submitMockQuestionResults`,
        {
            user_id: userId,
            short_format_answers: answers,
            mock_name: mock_name
        }
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error submitting mock question results:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function getUserMockQuestionResults(userId, mock_name) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/getUserMockQuestionResults?user_id=${userId}&mock_name=${mock_name}`
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error fetching user mock question results:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function checkUserMockQuestionResults(userId, mock_name) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/checkUserMockQuestionResults?user_id=${userId}&mock_name=${mock_name}`
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error checking user mock question results:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function getUserLongFormatScores(userId, mock_name) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/getUserLongFormatScores?user_id=${userId}&mock_name=${mock_name}`
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error fetching user long format scores:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function hasUserSubmittedMock(userId, mock_name) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/hasUserSubmittedMock?user_id=${userId}&mock_name=${mock_name}`
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error checking user mock status:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function hasUserSubmittedShortFormat(userId, mock_name) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/hasUserSubmittedShortFormat?user_id=${userId}&mock_name=${mock_name}`
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error checking user mock status:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

export async function markMockAsComplete(userId, mock_name) {
  try {
    const response = await axios.put(
      `${baseURL}/question-bank/markMockAsComplete`,
        {
            user_id: userId,
            mock_name: mock_name
        }
    );
    return response.data; // Return the response from the backend
  } catch (error) {
    console.error("Error marking mock as complete:", error);
    throw error; // Rethrow error to be handled by the calling function
  }
}

//user progress stuff
export async function saveUserProgress(userId, subcatIds, lastQuestionIds) {
  const data = {
    userId,
    subcatIds,
    lastQuestionIds,
  };

  return await axios.post(`${baseURL}/userProgress/saveProgress`, data);
}

export async function getUserProgress(userId) {
  return await axios.get(`${baseURL}/userProgress/${userId}`);
}

export async function updateTimestamp(userId) {
  return await axios.post(`${baseURL}/userProgress/updateTimestamp/${userId}`);
}

//farqaans endpoints
export async function completeQuestion(userId, questionId, completed, result) {
  const data = {
    user_id: userId, // Make sure userId is not null
    question_id: questionId, // Make sure questionId is not null
    completed: completed,
    result: result,
  };
  console.log("Data to be sent:", data);

  return await axios.post(`${baseURL}/question-bank/completeQuestion`, data, {
    headers: {
      "Content-Type": "application/json", // Set the content type to JSON
    },
  });
}

export async function resetAllProgress(userId) {
  return await axios.post(
    `${baseURL}/question-bank/resetAllProgress/${userId}`
  );
}

export async function flagQuestion(userId, questionId, flagged, timestamp) {
  const data = {
    user_id: userId, // Make sure userId is not null
    question_id: questionId,
    timestamp,
  };

  return await axios.post(`${baseURL}/question-bank/flagQuestion`, data);
}

export async function unflagQuestion(userId, questionId) {
  const data = {
    user_id: userId, // Make sure userId is not null
    question_id: questionId,
  };

  return await axios.post(`${baseURL}/question-bank/unflagQuestion`, data);
}

export async function reviewFlaggedQuestions(userId) {
  return await axios.get(
    `${baseURL}/question-bank/reviewFlaggedQuestions/${userId}`
  );
}

export async function getAllScoresForPercentile() {
  return await axios.get(`${baseURL}/question-bank/getAllScoresForPercentile`);
}

export async function getAllUserScores() {
  return await axios.get(`${baseURL}/question-bank/getAllUserScores`);
}

export async function getUserAverageScore(userId) {
  return await axios.get(
    `${baseURL}/question-bank/getUserAverageScore?user_id=${userId}`
  );
}
export async function getScoresFromCourse(course, universityName) {
  const queryParams = universityName
    ? `?course=${course}&university_name=${universityName}`
    : `?course=${course}`;

  return await axios.get(
    `${baseURL}/question-bank/getScoresFromCourse${queryParams}`
  );
}

export async function getScoresFromYear(class_year) {
  return await axios.get(
    `${baseURL}/question-bank/getScoresFromYear?class_year=${class_year}`
  );
}

export async function removeFromReview(userId, questionId) {
  const data = {
    user_id: userId, // Make sure userId is not null
    question_id: questionId,
  };

  return await axios.post(`${baseURL}/question-bank/removeFromReview`, data);
}

export async function mockTestQuestions() {
  return await axios.get(`${baseURL}/question-bank/mockTestQuestions`);
}

export async function retrieveFromReview(userId, catId = "", subcatId = "") {
  return await axios.get(
    `${baseURL}/question-bank/retrieveFromReview?user_id=${userId}&cat_id=${catId}&subcat_id=${subcatId}`
  );
}

export async function retrieveFromMockReview(
  userId,
  catId = "",
    subcatId = ""
) {
  return await axios.get(
    `${baseURL}/question-bank/retrieveFromMockReview?user_id=${userId}&cat_id=${catId}&subcat_id=${subcatId}`
  );
}

export async function removeFromMockReview(userId, questionId) {
  const data = {
    user_id: userId, // Make sure userId is not null
    question_id: questionId,
  };

  return await axios.post(
    `${baseURL}/question-bank/removeFromMockReview`,
    data
  );
}

export async function insertForMockReview(
  userId,
  questionId,
  questionText, // Add question_text parameter
  userOptionText,
  correctOptionText,
    correct,
  mock_name,
) {
  const data = {
    user_id: userId,
    question_id: questionId,
    question_text: questionText, // Include question_text in data
    user_option_text: userOptionText,
    correct_option_text: correctOptionText,
      correct,
    mock_name,
  };
  try {
    const response = await axios.post(
      `${baseURL}/question-bank/insertForMockReview`,
      data
    );
    return response;
  } catch (error) {
    console.error(
      "Error in Axios call:",
      error.response ? error.response.data : error
    );
    throw error; // Re-throw the error so it can be caught where the function is called
  }
}

export async function deleteUserMockData(userId, mock_name) {
  return await axios.delete(
    `${baseURL}/question-bank/deleteUserMockData?user_id=${userId}&mock_name=${mock_name}`
  );
}

export async function submitTest(
  userId,
  universityName,
  classYear,
  score,
  courseName
) {
  const data = {
    user_id: userId,
    university_name: universityName,
    class_year: classYear,
    score: score,
    course: courseName,
  };

  return await axios.post(`${baseURL}/question-bank/submitTest`, data);
}

export async function insertForReview(
  userId,
  questionId,
  questionText, // Add question_text parameter
  userOptionText,
  correctOptionText,
  correct
) {
  const data = {
    user_id: userId,
    question_id: questionId,
    question_text: questionText, // Include question_text in data
    user_option_text: userOptionText,
    correct_option_text: correctOptionText,
    correct,
  };
  try {
    const response = await axios.post(
      `${baseURL}/question-bank/insertForReview`,
      data
    );
    return response;
  } catch (error) {
    console.error(
      "Error in Axios call:",
      error.response ? error.response.data : error
    );
    throw error; // Re-throw the error so it can be caught where the function is called
  }
}

export async function howManyQuestionsAreThereTotal(course, university_name) {
  const queryParams = university_name
    ? `?course=${course}&university_name=${university_name}`
    : `?course=${course}`;

  return await axios.get(
    `${baseURL}/question-bank/howManyQuestionsAreThereTotal${queryParams}`
  );
}

export async function howManyQuestionsCorrect(user_id) {
  return await axios.get(
    `${baseURL}/question-bank/howManyQuestionsCorrect?user_id=${user_id}`
  );
}

export async function howManyQuestionsIncorrect(user_id) {
  return await axios.get(
    `${baseURL}/question-bank/howManyQuestionsIncorrect?user_id=${user_id}`
  );
}

export async function howManyQuestionsAttempted(user_id) {
  return await axios.get(
    `${baseURL}/question-bank/howManyQuestionsAttempted?user_id=${user_id}`
  );
}

export async function resumeSession(userId) {
  return await axios.get(
    `${baseURL}/question-bank/resumeSession?user_id=${userId}`
  );
}

export async function saveSession(data) {
  console.log("datatobesent", data);
  return await axios.post(`${baseURL}/question-bank/saveSession`, data, {
    headers: {
      "Content-Type": "application/json", // Set the content type to JSON
    },
  });
}

export async function deleteSession(userId) {
  return await axios.delete(
    `${baseURL}/question-bank/deleteSession?user_id=${userId}`
  );
}

export async function reportQuestionInsert(
  questionId,
  problem,
  university,
  course,
  category,
  subcategory,
  date
) {
  const data = {
    questionId, // Match key names
    problem,
    university,
    course,
    category,
    subcategory,
    date,
  };

  try {
    const response = await axios.post(
      `${baseURL}/question-bank/reportQuestionInsert`,
      data
    );
    return response;
  } catch (error) {
    console.error(
      "Error in Axios call:",
      error.response ? error.response.data : error
    );
    throw error;
  }
}

export async function getQuestionImageLink(questionId) {
  return await axios.get(
    `${baseURL}/question-bank/getQuestionImageLink?question_id=${questionId}`
  );
}

export async function getQuestionImageLinkForMock(questionId) {
  return await axios.get(
    `${baseURL}/question-bank/getQuestionImageLinkForMock?question_id=${questionId}`
  );
}
//commen

//comments

// In your frontend axios file (auth.js or similar)
export async function getCommentsByQuestionId(questionId, userId) {
  return await axios.get(
    `${baseURL}/question-bank/questions/${questionId}/comments`,
    {
      params: { userId },
    }
  );
}

export async function addComment(commentData) {
  const { question_id, user_id, comment_text, parent_comment_id } = commentData;
  // Update the URL to match the correct base path
  return await axios.post(
    `${baseURL}/question-bank/questions/${question_id}/comments`,
    {
      user_id,
      comment_text,
      parent_comment_id,
    }
  );
}

export async function likeComment(commentData) {
  const { user_id, comment_id, is_like } = commentData;
  return await axios.post(`${baseURL}/question-bank/comments/like`, {
    user_id,
    comment_id,
    is_like, // true for like, false for dislike
  });
}

//portal endpoints start here

const safeParse = (v) => {
  try {
    if (v == null) return null;
    return typeof v === "string" ? JSON.parse(v) : v;
  } catch {
    return null;
  }
};

export async function getQuestionsForReview(
  reviewerId,
  limit = 20,
  offset = 0,
  isMockBank = false
) {
  try {
    console.log(
      `Fetching questions: reviewerId=${reviewerId}, limit=${limit}, offset=${offset}`
    );
    const response = await axios.get(
      `${baseURL}/question-bank/questions-for-review`,
      {
        params: {
          reviewer_id: reviewerId,
          limit,
          offset,
          is_mock_bank: isMockBank ? "true" : "false",
        },
      }
    );
    console.log("API Response Data:", response.data);

    // Normalize JSON fields so the UI can rely on arrays
    const questions = (response.data.questions || []).map((q) => ({
      ...q,
      choices: Array.isArray(q.choices)
        ? q.choices
        : safeParse(q.choices) ?? [],
      feedback_history: Array.isArray(q.feedback_history)
        ? q.feedback_history
        : safeParse(q.feedback_history) ?? [],
      child_question_ids: Array.isArray(q.child_question_ids)
        ? q.child_question_ids
        : safeParse(q.child_question_ids) ?? [],
    }));

    return { ...response.data, questions };
  } catch (error) {
    console.error("Error fetching questions for review:", error);
    throw error;
  }
}

// Function to submit a review
export async function submitReview({
  question_id,
  reviewer_id,
  is_confirmed,
  feedback_text,
}) {
  try {
    const response = await axios.post(
      `${baseURL}/question-bank/submit-review`,
      {
        question_id,
        reviewer_id,
        is_confirmed,
        feedback_text,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error submitting review:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
}

// uploading questions
// NOTE: If you include child_question_ids in formData, it will be forwarded as-is.
export async function uploadQuestion(data) {
  const isFD = typeof FormData !== "undefined" && data instanceof FormData;
  const config = isFD
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : {};
  const response = await axios.post(
    `${baseURL}/question-bank/upload`,
    data,
    config
  );
  return response.data;
}

// Function to fetch reviewed questions
export async function getReviewedQuestions(uploaderId, isMockBank = false) {
  try {
    console.log(`Fetching reviewed questions for uploaderId=${uploaderId}`);

    const response = await axios.get(
      `${baseURL}/question-bank/reviewed-questions`,
      {
        params: {
          uploader_id: uploaderId,
          is_mock_bank: isMockBank ? "true" : "false",
        },
      }
    );
    console.log("API Response Data:", response.data);

    const reviewedQuestions = (response.data.reviewedQuestions || []).map(
      (question) => ({
        ...question,
        // Ensure JSON arrays are parsed
        choices: Array.isArray(question.choices)
          ? question.choices
          : safeParse(question.choices) ?? [],
        feedback_history: Array.isArray(question.feedback_history)
          ? question.feedback_history
          : safeParse(question.feedback_history) ?? [],
        child_question_ids: Array.isArray(question.child_question_ids)
          ? question.child_question_ids
          : safeParse(question.child_question_ids) ?? [],
      })
    );

    return { ...response.data, reviewedQuestions };
  } catch (error) {
    console.error("Error fetching reviewed questions:", error);
    throw error;
  }
}

export async function getConfirmedQuestionsCount(
  uploaderId,
  isMockBank = false
) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/confirmed-questions-count`,
      {
        params: {
          uploader_id: uploaderId,
          is_mock_bank: isMockBank ? "true" : "false",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching confirmed questions count:", error.message);
    throw error;
  }
}

export async function uploadChoice(choiceData) {
  try {
    const response = await axios.post(
      `${baseURL}/question-bank/upload-choice`,
      choiceData
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading choice:", error.message);
    throw error;
  }
}

// NOTE: Allow child_question_ids in updatedQuestionData if you want to update SAQ JSON.
export async function updateQuestion(updatedQuestionData) {
  try {
    const response = await axios.put(
      `${baseURL}/question-bank/update-question`,
      updatedQuestionData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating question:", error.message);
    throw error;
  }
}

export async function addCategory(data) {
  try {
    const response = await axios.post(
      `${baseURL}/question-bank/add-category`,
      data
    ); // Prepend baseURL
    return response.data;
  } catch (error) {
    console.error("Error adding category:", error.message);
    throw error;
  }
}

export async function addSubcategory(data) {
  try {
    const response = await axios.post(
      `${baseURL}/question-bank/add-subcategory`,
      data
    ); // Prepend baseURL
    return response.data;
  } catch (error) {
    console.error("Error adding subcategory:", error.message);
    throw error;
  }
}

export const getReviewedQuestionsCount = async (
  reviewerId,
  isMockBank = false
) => {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/reviewed-questions-count`,
      {
        params: {
          reviewer_id: reviewerId,
          is_mock_bank: isMockBank ? "true" : "false",
        },
      }
    );
    return response.data.reviewedCount;
  } catch (error) {
    console.error("Error fetching reviewed questions count:", error.message);
    throw error;
  }
};

export async function getCategories(universityName) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/categories/all?university_name=${encodeURIComponent(
        universityName
      )}`
    );
    return response.data.categories;
  } catch (error) {
    console.error("Error fetching categories:", error.message);
    throw error;
  }
}

export async function getSubcategories(universityName, courseName) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/subcategories/all`,
      {
        params: {
          university_name: universityName,
          course_name: courseName, // Ensure correct parameter is passed
        },
      }
    );
    return response.data.subcategories;
  } catch (error) {
    console.error("Error fetching subcategories:", error.message);
    throw error;
  }
}

export async function getStagedQuestions(
  queryString = "",
  isMockBank = false
) {
  try {
    const params = new URLSearchParams(queryString || "");
    params.set("is_mock_bank", isMockBank ? "true" : "false");
    const qs = params.toString();
    const response = await axios.get(
      `${baseURL}/question-bank/staged-questions?${qs}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching staged questions:", error.message);
    throw error;
  }
}

export async function releaseStagedQuestions(
  university,
  { isMockBank = false, mockName } = {}
) {
  try {
    const body = {
      university,
      is_mock_bank: isMockBank,
    };
    if (mockName != null && String(mockName).trim()) {
      body.mock_name = String(mockName).trim();
    }
    const response = await axios.post(
      `${baseURL}/question-bank/release-staged-questions`,
      body
    );
    return response.data;
  } catch (error) {
    console.error("Error releasing staged questions:", error.message);
    throw error;
  }
}

export async function getUploadedQuestions(filters = {}) {
  try {
    const response = await axios.get(
      `${baseURL}/question-bank/uploaded-questions`,
      {
        params: filters,
      }
    );
    return response.data.uploadedQuestions;
  } catch (error) {
    console.error("Error fetching uploaded questions:", error.message);
    throw error;
  }
}

export async function assignQuestionsToMe({ university, course, is_mock_bank }) {
  try {
    const response = await axios.post(`${baseURL}/question-bank/assign-to-me`, {
      university,
      course,
      is_mock_bank,
    });
    return response.data;
  } catch (error) {
    console.error("Error assigning questions:", error.message);
    throw error;
  }
}

export async function getAdminUsers(filters = {}) {
  try {
    const response = await axios.get(`${baseURL}/admin/users`, { params: filters });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin users:", error.message);
    throw error;
  }
}

export async function getAdminUserDetail(userId) {
  try {
    const response = await axios.get(`${baseURL}/admin/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching admin user detail:", error.message);
    throw error;
  }
}

export async function updateAdminUser(userId, payload) {
  try {
    const response = await axios.patch(`${baseURL}/admin/users/${userId}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating admin user:", error.message);
    throw error;
  }
}

export async function adminForcePassword(userId, temporary_password) {
  try {
    const response = await axios.post(
      `${baseURL}/admin/users/${userId}/force-password`,
      temporary_password ? { temporary_password } : {}
    );
    return response.data;
  } catch (error) {
    console.error("Error forcing password:", error.message);
    throw error;
  }
}

export async function getAdminSiteMetrics() {
  try {
    const response = await axios.get(`${baseURL}/admin/site-metrics`);
    return response.data;
  } catch (error) {
    console.error("Error fetching admin site metrics:", error.message);
    throw error;
  }
}

export const updateAvatarAPI = async (userId, avatarPath) => {
  try {
    const response = await axios.post(`${baseURL}/update-avatar`, {
      userId,
      avatarPath,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating avatar:", error);
    throw error;
  }
};

export const getRandomQuestionForSocialMediaDentistry = async (userId) => {
    try {
        // Use 'params' to send data via query string
        // Also ensure key matches backend: user_id
        const response = await axios.get(`${baseURL}/question-bank/get-random-question-for-social-media-dentistry`, {
            params: { user_id: userId }
        });
        return response.data;
    } catch (error) {
        console.error("error retrieving question", error);
        throw error;
    }
};

export const getRandomQuestionForSocialMediaMedicine = async (userId) => {
    try {
        const response = await axios.get(`${baseURL}/question-bank/get-random-question-for-social-media-medicine`, {
            params: { user_id: userId }
        });
        return response.data;
    } catch (error) {
        console.error("error retrieving question", error);
        throw error;
    }
};